/**
 * In Germany a VAT-exempt business may still hold a USt-IdNr and must be able to
 * display it on invoices. Other markets keep VAT ID coupled to exemption.
 */

export const shouldAllowVatNumberWhenExempt = (countryId: string | null | undefined): boolean => countryId === 'DE'
